"use client"

import { ColumnDef } from "@tanstack/react-table"
import { formatRelativeTime } from "~/common/format-relative-time"
import { parseISO } from "date-fns"

export type NewsletterInputColumns = {
  id: string
  subject?: string | null
  sender?: string | null
  originalSender?: string | null
  state: string
  createdAt: string
}

const statusMapping: Record<string, string> = {
  INITIAL: "Received",
  CLASSIFYING: "Classifying",
  EXTRACTING_SUMMARIES: "Extracting Summaries",
  EXTRACTING_TOPICS: "Extracting Topics",
  ANALYSIS_COMPLETE: "Analysis Complete",
  NOT_NEWSLETTER: "Not Newsletter",
  PROHIBITED_CONTENT: "Prohibited Content",
  SOURCE_INACTIVE: "Source Inactive",
}

export const columns: ColumnDef<NewsletterInputColumns | null | undefined>[] = [
  {
    accessorKey: "sender",
    header: "Sender",
    cell: ({ row, cell }) => {
      const sender = row.getValue("sender") as string | null | undefined
      const originalSender = cell.row.original?.originalSender as string | null | undefined
      return <div className="text-sm text-gray-400">{originalSender || sender || "-"}</div>
    },
  },
  {
    accessorKey: "subject",
    header: "Subject",
    cell: ({ row }) => {
      const subject = row.getValue("subject") as string | null | undefined
      return <div className="text-sm">{subject || "-"}</div>
    },
  },
  {
    accessorKey: "state",
    header: "State",
    cell: ({ row }) => {
      const state = row.getValue("state") as string
      const displayState = statusMapping[state]
      return <div className="text-sm">{displayState}</div>
    },
  },
  {
    accessorKey: "createdAt",
    header: "Received",
    cell: ({ row }) => {
      const createdAt = row.getValue("createdAt") as string
      return <div className="text-sm">{formatRelativeTime(parseISO(createdAt))}</div>
    },
  },
]
